import { render } from "./OtherSettings.vue?vue&type=template&id=5e986ce5&scoped=true"
import script from "./OtherSettings.vue?vue&type=script&lang=js"
export * from "./OtherSettings.vue?vue&type=script&lang=js"

import "./OtherSettings.vue?vue&type=style&index=0&id=5e986ce5&lang=scss&scoped=true"

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e986ce5"]])

export default __exports__